module.exports = __webpack_public_path__ + "img/customer-service.bf39fcd.png";